import React, { Component } from "react";
import { View } from "react-native";

import { CheckBox } from "components";
import { markSelectedItems } from "state/modules/survey/selectors";

import { styles } from "./styles";

export class ProductQuestion extends Component {
  getItems = () => {
    const { items, question, response } = this.props;
    const [option] = question.options;
    const questionId = question.virtual_id;
    const optionId = option.virtual_id;
    return markSelectedItems(items, { questionId, optionId }, response);
  };

  render = () => {
    const { question, isEnglish } = this.props;
    const items = this.getItems();

    const containerStyles = [];
    if (items.length > 3) {
      containerStyles.push(styles.container);
    }

    if (!isEnglish && items.length > 3) {
      containerStyles.push(styles.containerRTL);
    }

    const size = styles._checkbox?.fontSize;

    return (
      <View style={containerStyles}>
        {items.map(item => {
          const checkBoxProps = {
            size,
            text: item.name,
            iconRight: !isEnglish,
            checked: item.isSelected,
            onPress: () => this.props.selectItemForQuestion(question, item),
          };
          return (
            <View key={item.id} style={styles.checkbox}>
              <CheckBox {...checkBoxProps} />
            </View>
          );
        })}
      </View>
    );
  };
}
